<template>
  <div>
    <div class="top_title">
      <i class="top_icon"></i>
      <span class="top_mess">松山智慧停车</span>
    </div>
    <div class="top_img"></div>
    <mainV2 />
    <div class="bottom">
      <div style="width:600px;margin:0 auto; padding:20px 0;">
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 10px 0px 5px; color:#939393;"
          >
            蒙ICP备 2022003818号 -1
          </p>
        </a>

        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15040402000318"
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
        >
          <img src="./img/badge.png" style="float:left;" />
          <p
            style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
          >
            蒙公网安备 15040402000318号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import mainV2 from './mainV2'
export default {
  name: "m_index",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  components: {
    mainV2
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
}
.top_title {
  width: 100%;
  background: #000000;
  opacity: 0.4;
  height: 130px;
  position: fixed;
  top: 0;
  left: 0;
}
.top_mess {
  float: left;
  display: inline-block;
  height: 130px;
  line-height: 130px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  margin-left: 30px;
}
.top_icon {
  display: inline-block;
  width: 100px;
  height: 100px;
  background: url("./img/logo.png");
  background-size: 100% 100%;
  margin: 15px 0 15px 50px;
  float: left;
}
.top_img {
  width: 100%;
  height: 800px;
  background: url("./img/titleImg.png") no-repeat;
  background-size: 100% 100%;
}
.bottom {
  width: 100%;
  height: 130px;
  background: #000000;
  color: #ffffff;
  text-align: left;
  line-height: 130px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding-left: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_index.vue